import { render, staticRenderFns } from "./TaskNewFrProject.vue?vue&type=template&id=1baea95a"
import script from "./TaskNewFrProject.vue?vue&type=script&lang=js"
export * from "./TaskNewFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports